import { Route, Routes } from "react-router-dom";
import { CallbackPage } from "./auth/CallbackPage";
import { TenantGate } from "./auth/TenantGate";
import { PlatformMap } from "./components/PlatformMap";

export function App() {
  return (
    <Routes>
      <Route path="/callback" element={<CallbackPage />} />
      <Route
        path="/*"
        element={
          <TenantGate>
            <PlatformMap />
          </TenantGate>
        }
      />
    </Routes>
  );
}
